import { useWorkspaceActions } from '@/hooks/useWorkspace';
import { api } from '@/lib/trpc/react';
import { toast } from 'sonner';

export const useIngestMetadata = () => {
  const { updateChatbot } = useWorkspaceActions();
  const utils = api.useUtils();

  const { mutateAsync: generateMetadata } =
    api.documentMetadata.generate.useMutation();

  const ingestGenerateMetadata = async (
    chatbotId: string,
    name: string | null,
  ) => {
    const data = await generateMetadata({ chatbotId });

    const userSettings = utils.userSettings.get.getData();
    utils.documentMetadata.byId.setData({ chatbotId: chatbotId }, () => data);

    updateChatbot(chatbotId, {
      name: data?.title ?? name,
      authors: data?.authors as string[],
      ...(data?.summary && { summary: data.summary }),
    });

    if (userSettings?.autoRenameEnabled && data?.title && data.title !== name)
      toast('Document name updated');
  };

  return { ingestGenerateMetadata };
};
